import React, { useEffect, useState } from "react";
import DashTable from "./DashTable";
import DashTabs from "./DashTabs";
import SearchBox from "../../../../Component/DigitalMarketing/SearchBox";
import { Col, Row } from "react-bootstrap";
import ComplaintsDetails from "./TemplateForms/ComplaintsDetails";
import HEDetails from "./TemplateForms/HE_Details";
import AdviceDetails from "./TemplateForms/AdviceDetails";
import DiagnosisDetails from "./TemplateForms/DiagnosisDetails";
import {
  useGetEHRAdviceQuery,
  useGetEHRComplaintsQuery,
  useGetEHRDiagnosisQuery,
  useGetHandEQuery,
} from "../../../../Service/Masters";
import Pagination from "../../../../Component/DigitalMarketing/Pagination";
import { useDispatch } from "react-redux";
import { Change } from "../../../../store/async-actions/digitalmarketing/header";
import Loader from "../../../../Component/DigitalMarketing/Loader";

const EhrTemplates = () => {
  const [show, setShow] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [updateData, setUpdateData] = useState<any>([]);
  const [tabName,setTabName] = useState("")
  const [pagination, setpagination] = useState(1);
  const dispatch = useDispatch()
  const pagi = {
    pageNo: pagination,
    name: "",
  };
  const { data: complaintsData, refetch,isLoading:complaintsLoading } = useGetEHRComplaintsQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
  const { data: HandEData, refetch: refetchHandE,isLoading:handELoading } = useGetHandEQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
  const { data: adviceData, refetch: refetchAdvice,isLoading:adviceLoading } = useGetEHRAdviceQuery(
    pagi,
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const { data: diagnosisData, refetch: refetchDiagnosis,isLoading:diagnosisLoading } =
    useGetEHRDiagnosisQuery(pagi, {
      refetchOnMountOrArgChange: true,
    });
    useEffect(() => {
      const data: any = {
        first: "EHR Templates",
      };
      dispatch(Change(data));
    }, [show]);
    if (complaintsLoading || adviceLoading || handELoading || diagnosisLoading) {
      return <Loader loading={true}/>;
    }
  return (
    <div>
      <div>
        <DashTabs
          setShow={setShow}
          show={show}
          setActiveIndex={setActiveIndex}
          setUpdateData={setUpdateData}
          setTabName={setTabName}
        />
      </div>

      <div className="row">
        <div className={show ? "col-8" : "col-12"}>
          <DashTable
            setShow={setShow}
            activeIndex={activeIndex}
            complaintsData={complaintsData}
            HandEData={HandEData}
            adviceData={adviceData}
            diagnosisData={diagnosisData}
            setUpdateData={setUpdateData}
            refetch={refetch}
            refetchHandE={refetchHandE}
            refetchAdvice={refetchAdvice}
            refetchDiagnosis={refetchDiagnosis}
          />
        </div>
        {show && (
          <div
            className="col-4 "
            style={{ backgroundColor: "white", height: "70vh" }}
          >
            {activeIndex === 1 && (
              <ComplaintsDetails
                refetch={refetch}
                updateData={updateData}
                setShow={setShow}
              />
            )}
            {activeIndex === 2 && (
              <HEDetails
                updateData={updateData}
                setShow={setShow}
                refetchHandE={refetchHandE}
              />
            )}
            {activeIndex === 3 && (
              <AdviceDetails
                updateData={updateData}
                setShow={setShow}
                refetchAdvice={refetchAdvice}
              />
            )}
            {activeIndex === 4 && (
              <DiagnosisDetails
                updateData={updateData}
                setShow={setShow}
                refetchDiagnosis={refetchDiagnosis}
              />
            )}
          </div>
        )}
        <Pagination
          setpagination={setpagination}
          pagination={pagination}
          data={
            activeIndex === 1
              ? complaintsData
              : activeIndex === 2
              ? HandEData
              : activeIndex === 3
              ? adviceData
              : diagnosisData
          }
        />
      </div>
    </div>
  );
};

export default EhrTemplates;
